/**
 * Phase H (Δ-13) — Category filter chips.
 *
 * CR-0014b polish (Δ-13b):
 *  - `rounded-full` → `rounded-md` (matches Reset button radius).
 *  - Mobile: row is `justify-center` for centred chip cluster.
 *
 * OR semantics within the active set (doc 06 §4.1). Only rendered
 * when `breakfast_started === true`. Optimistic click via
 * `useToggleCategoryFilter` (Δ-13a).
 */
import useAppStore from "@/store/useAppStore";
import { useToggleCategoryFilter } from "@/hooks/useTableMutations";
import { CATEGORY_COLORS, CATEGORY_PRIORITY } from "@/utils/categories";

const LABELS = { vip: "VIP", email: "Email", complain: "Complain" };

export default function CategoryFilterChips({ centerOnMobile = false }) {
  const breakfastStarted = useAppStore((s) => s.appState?.breakfast_started);
  const activeFilters = useAppStore(
    (s) => s.appState?.active_category_filters || []
  );
  const toggle = useToggleCategoryFilter();

  if (!breakfastStarted) return null;

  const justify = centerOnMobile ? "justify-center" : "";

  return (
    <div
      data-testid="category-filter-chips"
      className={`flex items-center gap-1.5 flex-wrap ${justify}`}
    >
      {CATEGORY_PRIORITY.map((cat) => {
        const active = activeFilters.includes(cat);
        const colors = CATEGORY_COLORS[cat];
        return (
          <button
            key={cat}
            data-testid={`category-filter-chip-${cat}`}
            data-active={active ? "true" : "false"}
            onClick={() => toggle.mutate({ category: cat, active: !active })}
            className="inline-flex items-center gap-1.5 rounded-md px-3 py-1 text-xs font-medium"
            style={{
              backgroundColor: active ? colors.bg : "#FFFFFF",
              border: `1px solid ${active ? colors.border : "#E0E0E0"}`,
              color: "#424242",
            }}
          >
            <span
              className="inline-block rounded-full"
              style={{ width: 8, height: 8, backgroundColor: colors.dot }}
            />
            {LABELS[cat]}
          </button>
        );
      })}
    </div>
  );
}
